import type { PowerProject } from "../types";
import { ProcessControlTab } from "./ProcessControlTab";

/** Zakładka „Doradca AI" projektu. Sugestie AI (AdvisorTab) są na froncie wyłączone —
 * podpowiedzi bywały nietrafione, więc pokazujemy wyłącznie Kontrolę procesu.
 * Backend (DLC_05) liczy je dalej, wystarczy przywrócić AdvisorTab, żeby wróciły. */
export function AdvisorWorkspace({ connection }: { connection: PowerProject }) {
  return <ProcessControlTab connection={connection} />;
}
